import { useState } from "react";
import { IconPlus } from "./Icons";

export const FAQAccordion = ({ items, testid = "faq" }) => {
  const [open, setOpen] = useState(0);
  if (!items?.length) return null;
  return (
    <div className="faq-wrap" data-testid={testid}>
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <div className="faq-item" data-open={isOpen} key={i} data-testid={`${testid}-item-${i}`}>
            <button
              className="faq-q"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`${testid}-q-${i}`}
            >
              {f.q || f.question}
              <IconPlus width={20} height={20} />
            </button>
            <div className={`faq-a ${isOpen ? "open" : ""}`}>
              <div className="faq-a-inner">{f.a || f.answer}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
